"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateAccessRoleUnassign = void 0;
const client_1 = require("@apollo/client");
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const accessRoleUnassignMutation = (0, client_1.gql) `
  mutation AccessRoleUnassign($workspaceId: ID!, $roles: [RoleAssignDelete!]!) {
    accessRoleAssignDelete(workspace: $workspaceId, roles: $roles) {
      workspaceId
      permissions
      name
      isDefaultForNewUsers
      isDefaultAccessRoleManager
      isDefaultAccessRoleEmployee
      id
      assigns {
        userId
        created
      }
    }
  }`;
const mutateAccessRoleUnassign = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(accessRoleUnassignMutation, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.accessRoleAssignDelete;
};
exports.mutateAccessRoleUnassign = mutateAccessRoleUnassign;
